export enum SectionFeatureColor {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum SectionFeatureSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum SectionFeatureAlignment {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum SectionFeatureBgColor {
  XXXXDARK = 'xxxxdark',
}
